/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import { createSlice } from "@reduxjs/toolkit";
import { Tenant, TenantState } from "../../models";
import {} from "./organization-actions";
import OrganizationState from "../../models/storeModels/OrganzationState";

const initialSliceState: OrganizationState = {
  organizations: [],
  selectedOrganizationToEdit: {
    organizationID: "3",
    organizationName: "Electricity",
  },
};

const organizationSlice = createSlice({
  name: "organization",
  initialState: initialSliceState,

  extraReducers(builder) {},
  reducers: {},
});

export const data = [{
  key: '0',
  data: {
      name: 'SECO',
      user: '100',
      action: 'Folder'
  },
  children: [
      {
          key: '0-0',
          data: {
              name: 'Electricity',
              user: '200',
              action: 'Folder',
          },
          children: [
              {
                  key: '0-0-0',
                  data: {
                      name: 'Electricity 1',
                      user: '10',
                      action: 'Application'
                  }, 
                  children: [
                    {
                      key: '0-0-0-0',
                      data: {
                          name: 'Electricity A',
                          user: '10',
                          type: 'Application'
                      }
                    },
                    {
                      key: '0-0-0-1',
                      data: {
                          name: 'Koustov',
                          user: '0',
                          type: 'Application'
                      }
                    },
                  ]
              },
              {
                  key: '0-0-1',
                  data: {
                      name: 'Electricity 2',
                      user: '10',
                      type: 'Application'
                  }
              },
              {
                  key: '0-0-2',
                  data: {
                      name: 'Electricity 3',
                      user: '83',
                      action: 'Application'
                  }
              }
          ]
      },
      {
          key: '0-1',
          data: {
              name: 'Water',
              user: '30',
              action: 'Application'
          }
      },
      {
          key: '0-2',
          data: {
              name: 'Gas',
              user: '50',
              action: 'Application'
          }
      }
  ]
}]

export const organizationActions = organizationSlice.actions;

export default organizationSlice;
